import Obb from './appObbResources';
import transformError from '../shared/transformers/errorTransformer';
import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';

function getMainObbs(packageName) {
  return Obb.get({ packageName })
    .then(res => res.body)
    .catch(transformError);
}

function getPatchObbs({ packageName, mainObbId }) {
  return Obb.get({ packageName, mainObbId })
    .then(res => res.body)
    .catch(transformError);
}

function attach({ packageName, packageId, obbId }) {
  return Obb.attach({ packageName, packageId }, { id: obbId })
    .then(({ body }) => transformToCamelCase(body))
    .catch(transformError);
}

function detach({ packageName, packageId, obbId }) {
  return Obb.detach({ packageName, packageId, obbId })
    .then(({ body }) => transformToCamelCase(body))
    .catch(transformError);
}

export default {
  getMainObbs,
  getPatchObbs,
  attach,
  detach,
};
